<template>
	<v-container fluid>
		<div class="action-bar">
			<v-row>
				<v-col>
					<v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(null)">
						<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
					</v-btn>
					<v-btn v-if="inEditMode && user.id != 0" class="mr-2" color="primary" @click="newPasswordClick">
						<v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.generateNewPassword') }}
					</v-btn>
					<v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
						<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
					</v-btn>
					<v-btn class="mr-2" @click="backClick">
						<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
					</v-btn>
				</v-col>
			</v-row>
		</div>
		<v-row>
			<v-col cols="12" xl="3" lg="4" md="6">
				<v-card flat outlined>
					<v-card-text class="mt-0 pt-0">
						<v-row dense wrap>
							<v-col cols="12">
								<span class="user-account-title">Osnovne informacije</span>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.first_name"
									:errorBorder="!userValidation.first_name"
									:label="'* ' + $t('fields.firstName')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.last_name"
									:errorBorder="!userValidation.last_name"
									:label="'* ' + $t('fields.lastName')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.email"
									:errorBorder="!userValidation.email"
									:label="'* ' + $t('fields.email')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.contact_number"
									:label="$t('fields.contactNumber')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<Dropdown
									:readonly="!inEditMode"
									v-model="user.user_role_id"
									:ajax="true"
									:data="'user-roles'"
									:errorBorder="!userValidation.user_role_id"
									:label="'* ' + $t('fields.role')"
								></Dropdown>
							</v-col>
							<v-col v-if="user.id == 0" cols="12">
								<InputField
									:readonly="!inEditMode"
									v-model="user.password"
									:errorBorder="!userValidation.password"
									:label="'* ' + $t('fields.password')"
								></InputField>
							</v-col>
							<v-col cols="12">
								<CheckBox
									:readonly="!inEditMode"
									v-model="user.active"
									:label="$t('fields.active')"
								></CheckBox>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" xl="9" lg="8" md="6">
				<v-card flat outlined>
					<v-card-text class="mt-0 pt-0">
						<v-row dense wrap>
							<v-col cols="12">
								<span class="user-account-title">Prava pristupa</span>
							</v-col>
							<v-col cols="4">
								<span>Članovi - osobni podaci</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.members_personal_info"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Članovi - knjižara</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.members_bookstore"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Odjel</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.departments"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Ogranak</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.branches"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Uplatnice</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.payments"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Pretplate</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.subscriptions"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Izvješća</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.reports"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
						<v-row dense wrap>
							<v-col cols="4">
								<span>Postavke</span>
							</v-col>
							<v-col cols="8">
								<v-radio-group
									class="ma-0 pa-0"
									v-model="userPermission.settings"
									row
									dense
									:readonly="!inEditMode"
								>
									<v-radio label="Nema pristup" :value="0"></v-radio>
									<v-radio label="Ima pristup" :value="1"></v-radio>
									<v-radio label="Uređivanje" :value="2"></v-radio>
								</v-radio-group>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Dropdown from '../../trinkets/Dropdown';
import User from '../../../models/User';
import UserPermission from '../../../models/UserPermission';

export default {
	name: 'UserAccount',
	components: { CheckBox, InputField, Dropdown },
	data: function () {
		return {
			user: new User({ id: this.$route.params.id }),
			userPermission: new UserPermission({}),
			userValidation: new User({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'user-account',
			lockTimer: null,
		};
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.user.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.user.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		newPasswordClick() {
			let vm = this;
			this.$verify(this.$t('alerts.generatePasswordQuestion'), (result) => {
				if (result) {
					vm.saveClick(() => {
						vm.$APICall('post', 'password-recovery', { email: vm.user.email }, (data, success) => {
							if (success) {
								vm.$alert(vm.$t('alerts.passwordResetSuccess'));
							} else {
								vm.$alert(vm.$t('alerts.passwordResetFail'));
							}
							vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
							clearInterval(vm.lockTimer);
						});
					});
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		saveClick(after = null) {
			let success = true;

			if (this.user.first_name == '') {
				success = false;
				this.userValidation.first_name = false;
			} else {
				this.userValidation.first_name = true;
			}

			if (this.user.last_name == '') {
				success = false;
				this.userValidation.last_name = false;
			} else {
				this.userValidation.last_name = true;
			}

			if (this.user.email == '') {
				success = false;
				this.userValidation.email = false;
			} else {
				if (!this.$checkEmail(this.user.email)) {
					success = false;
					this.userValidation.email = false;
				} else {
					this.userValidation.email = true;
				}
			}

			if (this.user.id == 0) {
				if (this.user.password.trim() == '') {
					success = false;
					this.userValidation.password = false;
				} else {
					let passwordValidation = '';

					if (this.user.password.length < 8) {
						success = false;
						this.userValidation.password = false;
						passwordValidation += this.$t('alerts.passwordLength') + '<br />';
					}

					let letters = 0;
					let digits = 0;
					let others = 0;
					for (let i = 0; i < this.user.password.length; i++) {
						let character = this.user.password[i];
						let letter = character.toLowerCase() !== character.toUpperCase();
						let digit = character >= '0' && character <= 9;
						if (letter) letters++;
						if (digit) digits++;
						if (!letter && !digit) others++;
					}
					if (letters === 0) passwordValidation += this.$t('alerts.passwordLetters') + '<br />';
					if (digits === 0) passwordValidation += this.$t('alerts.passwordDigits') + '<br />';

					if (passwordValidation !== '') {
						this.$alert(passwordValidation);
						success = false;
					} else {
						this.userValidation.password = true;
					}
				}
			}

			if (this.user.user_role_id == null) {
				success = false;
				this.userValidation.user_role_id = false;
			} else {
				this.userValidation.user_role_id = true;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.user.id != 0) {
					action = 'put';
					addition = '/' + vm.user.id;
				}
				let data = {
					user: this.user,
					userPermission: this.userPermission,
				};
				this.$APICall(action, 'users' + addition, data, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.user.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.$triggerReload();
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.userExists'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.user.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(this, this.lockKey + '|' + this.user.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		let vm = this;
		if (this.user.id != 0) {
			this.$APICall('get', 'users/' + this.user.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$nextTick(() => {
						vm.initialLoad = true;
						vm.$myStore.commit('setBreadcrumbs', [
							{
								text: vm.$t('modules.userAccounts'),
								href: '/#/user-accounts',
								disabled: false,
							},
							{
								text: vm.user.first_name + ' ' + vm.user.last_name,
								href: '/#/user-accounts/' + vm.user.id,
								disabled: true,
							},
						]);
					});
					vm.user = usableData.user;
					if (usableData.userPermission) {
						vm.userPermission = usableData.userPermission;
					}
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.userAccounts'),
					href: '/#/user-accounts',
					disabled: false,
				},
				{
					text: this.$t('modules.newUserAccount'),
					href: '/#/user-accounts/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped>
.user-account-title {
	font-size: 1.3rem;
	line-height: 2.7rem;
	color: rgb(74, 74, 74);
}
</style>
